var scope_0 = require('/home/runner/work/yukseltolun.com/yukseltolun.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ca93d62d971b5924c28a362d44044932.js').default;
var scope_1 = require('/home/runner/work/yukseltolun.com/yukseltolun.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    